var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row boxes-row"},_vm._l((_vm.boxes),function(client){return _c('div',{key:client.id,staticClass:"col-lg-4"},[_c('ClientBox',{attrs:{"box":client}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }